import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FaInstagram,
  FaTwitter,
  FaFacebook,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";

import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer-section mt-5">
      <Container>
        <Row className="gy-4">
          {/* ---------- LOGO + TEXT ---------- */}
          <Col md={4}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src="./images/startup-logo.png"
                alt="logo"
                className="footer-logo img-fluid w-50"
              />

              <p className="footer-text">
                One platform, complete connectivity: journey effortlessly from
                deal sourcing to deal syndication with our integrated solution.
              </p>
            </motion.div>
          </Col>

          {/* ---------- SOLUTIONS ---------- */}
          <Col md={2}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h5 className="footer-title">Solutions</h5>
              <ul className="footer-links">
                <li>Deal Flow</li>
                <li>Demo Day</li>
              </ul>
            </motion.div>
          </Col>

          {/* ---------- QUICK LINKS ---------- */}
          <Col md={2}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h5 className="footer-title">Quick Links</h5>
              <ul className="footer-links">
                <li>Blog</li>
                <li>Privacy Policy</li>
              </ul>
            </motion.div>
          </Col>

          {/* ---------- CONTACTS ---------- */}
          <Col md={4}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h5 className="footer-title">Contact Us</h5>

              <p className="footer-contact">
                <a href="mailto:info@startupsteroid.in">
                  📧 info@startupsteroid.in
                </a>
              </p>

              <p className="footer-contact">
                <a href="tel:+919824018555">📞 +91 98240 18555</a>
              </p>

              {/* Social Icons with links */}
              <div className="social-wrapper">
                <a
                  href="https://instagram.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaInstagram className="social-icon" />
                </a>

                <a href="https://twitter.com/" target="_blank" rel="noreferrer">
                  <FaTwitter className="social-icon" />
                </a>

                <a
                  href="https://facebook.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebook className="social-icon" />
                </a>

                <a href="https://youtube.com/" target="_blank" rel="noreferrer">
                  <FaYoutube className="social-icon" />
                </a>

                <a
                  href="https://linkedin.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaLinkedin className="social-icon" />
                </a>
              </div>
            </motion.div>
          </Col>
        </Row>

        {/* ---------- COPYRIGHT ---------- */}
        <Row>
          <Col className="text-center mt-4">
            <motion.p
              className="footer-copy"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
            >
              Copyright © 2025 All rights reserved.
            </motion.p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
